import { provideConfig } from '@spartacus/core'
import { NgModule } from '@angular/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import {
  HEADER_INTRO_TEXT_FOR_PROTOCOL_CONVERTER_TOKEN, HeaderIntroTextForProtocolConverter
} from './header-intro-text-for-protocol.component.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        headerIntroTextForProtocolFeature: {
          module: () => import('./header-intro-text-for-protocol.module').then((m) => m.HeaderIntroTextForProtocolModule),
          cmsComponents: ['header_intro_text_for_protocol'],
        },
      }
    }),
    {
      provide: HEADER_INTRO_TEXT_FOR_PROTOCOL_CONVERTER_TOKEN,
      useExisting: HeaderIntroTextForProtocolConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        header_intro_text_for_protocol: HEADER_INTRO_TEXT_FOR_PROTOCOL_CONVERTER_TOKEN
      },
      multi: true
    }
  ]
})
export class HeaderIntroTextForProtocolFeatureModule {}
